import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class AngularErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private authService: AuthService
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 429) {
          this.sharedService.errorOccured = true;
          this.authService.sessionId2 = (error as any).error.sessionId
          this.router.navigate(['error'], {
            queryParams: {
              errorMessage:
                environment.language === 'it_IT'
                  ? 'Già registrato'
                  : 'Already Logged In',

              errorStatus:
                environment.language === 'it_IT'
                  ? 'Blocco sessione'
                  : 'Session Lock',

              errorCode: '429'
            }
          });
        }
        if (error.status === 440) {
          this.sharedService.errorOccured = true;
          this.authService.logout();
          if (this.sharedService.isRDD) {
            this.router.navigate(['sdp/rddsignin']);
          } else if (this.sharedService.isInterviewer) {
            this.router.navigate(['sdp/interviewersignin']);
          } else {
            this.router.navigate(['sdp/signin']);
          }
        }
        if (error.status === 428) {
          this.sharedService.errorOccured = true;
          this.authService.logout();
          if (this.sharedService.isRDD) {
            this.router.navigate(['sdp/rddsignin']);
          } else if (this.sharedService.isInterviewer) {
            this.router.navigate(['sdp/interviewersignin']);
          } else {
            this.router.navigate(['sdp/signin']);
          }
        }
        // if (error.status === 401) {
        //   this.sharedService.errorOccured = true;
        //   this.authService.logout();
        //   this.router.navigate(['sdp/signin']);
        // }
        return throwError(error);
      })
      // tap(
      //   res => {},
      //   error => {
      //     if (error instanceof HttpErrorResponse) {
      //       if (error.status === 429) {
      //         this.router.navigate(['error'], {
      //           queryParams: {
      //             errorMessage:
      //               environment.language === 'it_IT'
      //                 ? 'Già registrato'
      //                 : 'Already Logged In',

      //             errorStatus:
      //               environment.language === 'it_IT'
      //                 ? 'Blocco sessione'
      //                 : 'Session Lock',

      //             errorCode: '429'
      //           }
      //         });
      //       }
      //     }
      //   }
      // )
    );
  }
}
